module.exports = __webpack_public_path__ + "static/icons_startseite_kinder-f83ae87f13de03e472167c871e707860.png";